import AuthenticationService from '@modules/Authentication/services/authentication.service';

const defaults = {
  token: null,
  data: {}
};

let _resolveUserLoaded;
let _rejectUserLoaded;
let _userLoadedPromise;
let _userLoadInFlight = null;

function openUserLoadedWaiter() {
  _userLoadedPromise = new Promise((resolve, reject) => {
    _resolveUserLoaded = resolve;
    _rejectUserLoaded = reject;
  });
}

openUserLoadedWaiter();

function userDataReady(data) {
  return Boolean(data && (data.id || data.feature_access));
}

export function waitForUserData() {
  return _userLoadedPromise;
}

export default {
  state: Object.assign({}, defaults),

  mutations: {
    setUser(state, data) {
      state.data = data;
      if (_resolveUserLoaded) {
        _resolveUserLoaded(data);
        _resolveUserLoaded = null;
        _rejectUserLoaded = null;
      }
    },
    setToken(state, data) {
      state.token = data;
    },
    failUserLoad(state) {
      state.data = {};
      if (_rejectUserLoaded) {
        _rejectUserLoaded(new Error('user load failed'));
        _rejectUserLoaded = null;
        _resolveUserLoaded = null;
      }
      openUserLoadedWaiter();
    },
    clear(state) {
      state.token = null;
      state.data = {};
      _userLoadInFlight = null;
      if (_rejectUserLoaded) {
        _rejectUserLoaded(new Error('cleared'));
        _rejectUserLoaded = null;
        _resolveUserLoaded = null;
      }
      openUserLoadedWaiter();
    }
  },

  actions: {
    CLEAR({ commit }) {
      commit('clear');
    },
    SETUSER({ commit }, data) {
      commit('setUser', data);
    },
    SETTOKEN({ commit }, data) {
      commit('setToken', data);
    },
    FAILUSERLOAD({ commit }) {
      commit('failUserLoad');
    },
    async ENSUREUSER({ commit, state }) {
      if (userDataReady(state.data)) {
        return state.data;
      }
      if (_userLoadInFlight) {
        return _userLoadInFlight;
      }
      _userLoadInFlight = (async () => {
        try {
          const data = await AuthenticationService.getImpersonatedUser();
          commit('setUser', data);
          return data;
        } catch (e) {
          commit('failUserLoad');
          throw e;
        } finally {
          _userLoadInFlight = null;
        }
      })();
      return _userLoadInFlight;
    }
  }
};
